import React from 'react';
import { UserMessage } from '../../../DesignSystem/LiliUserMessage/UserMessage';

const TransferSuccessPopup = ({ children, featureName = 'bankTransfer' }: { children: React.ReactNode, featureName?: string }) => (
  <UserMessage onClick={() => {}} id={`${featureName}SuccessModal`}>
    <div id={`${featureName}SuccessPopup`} className='flex flex-col items-center justify-center py-[24px] px-[24px] bg-bw02 rounded-[8px]'>
      {children}
    </div>
  </UserMessage>
);

export default TransferSuccessPopup;
